import { DataDisplay, formatCurrency, formatPercent, Grid, pn, Typography, useElementBreakpoints } from "@compass/core";
import { ContributorMatch, ContributorMatchViewResource } from "generated/openApi";
import "moment-timezone";
import { Field } from "devextreme-react/data-grid";

export const SideInfo = (props: { match: ContributorMatch; viewResource: ContributorMatchViewResource }) => {
  const { breakpointsRef, xSmallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("hourlySalary"))?.displayName}
        >
          {formatCurrency(props.match.hourlySalary)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay label={properties.find((x) => x.propertyName === pn<ContributorMatch>("amount"))?.displayName}>
          {formatCurrency(props.match.amount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("benefitAmount"))?.displayName}
        >
          {formatCurrency(props.match.benefitAmount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("medicalBenefitAmount"))?.displayName}
        >
          {formatCurrency(props.match.medicalBenefitAmount)}
        </DataDisplay>
      </Grid>

      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={
            <Typography sx={{ color: "#08519c" }}>
              {properties.find((x) => x.propertyName === pn<ContributorMatch>("totalAmount"))?.displayName}
            </Typography>}
        >
          <Typography sx={{ color: "#08519c" }}>
            {formatCurrency(props.match.totalAmount)}
          </Typography>
        </DataDisplay>
      </Grid>

      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("milesAmount"))?.displayName}
        >
          {formatCurrency(props.match.milesAmount)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={properties.find((x) => x.propertyName === pn<ContributorMatch>("indirectPercent"))?.displayName}
        >
          {formatPercent(props.match.indirectPercent)}
        </DataDisplay>
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        <DataDisplay
          label={
            <Typography sx={{ color: "#08519c" }}>
              {properties.find((x) => x.propertyName === pn<ContributorMatch>("indirectCostAmount"))?.displayName}
            </Typography>
          }
        >
          <Typography sx={{ color: "#08519c" }}>
            {formatCurrency(props.match.indirectCostAmount)} </Typography>
        </DataDisplay>
      </Grid>
    </Grid>
  );
};
